import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone,
  map,
  filter,
} from 'ramda';
import Input from '../../common/Input';
import Select from '../../common/Select';
import TextArea from '../../common/TextArea';
import MultiSelect from '../../common/MultiSelect';
import fields from './fields';
import { processFields } from '../../utils/prePost';
import { validateFields } from '../../utils/validate';
import Breadcrumbs from '../../common/Breadcrumbs';
import '../../css/forms/default-forms.css';

import { linkDataToFields } from '../../utils/fields';
import { fetchLaneById, refreshLane } from '../../api/boardLane';

import { fetchShops } from '../../api/shops';
import { getList } from '../../api/projects';
import hasAccess from "../../helpers/permissionChecker";


export class EditLane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      errors: [],
      fields: fields,
      fieldsSync: false,
    };
    this.submit = this.submit.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.cancel = this.cancel.bind(this);

    this.getProjectList = this.getProjectList.bind(this);
    this.getShopList = this.getShopList.bind(this);
    this.fetchDataRouteById = this.fetchDataRouteById.bind(this);

    this.convertArrForMultiselect = this.convertArrForMultiselect.bind(this);
    this.convertArrToSend = this.convertArrToSend.bind(this);
  }

  componentWillMount() {
    this.props.shopList();
    this.props.projectList();
    this.fetchDataRouteById();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.fieldsSync === false) {
      let currentLane = path(['boardLane', 'lane'], this.props);
      
      if (currentLane) {
        const fields = linkDataToFields(currentLane, this.state.fields, {
          project_ids: function(field, data) {            
            var arr = [];
            const projects = data.length > 0 ? this.convertArrForMultiselect(data) : []
            if (projects.length > 0){
              for (let key in projects) {
                let cVal = projects[key];

                arr.push({
                  value: cVal.id,
                  checked: cVal.value ? cVal.value : false,
                  label: cVal.name
                });

              }
            } else {
              arr = this.getProjectList();
            }
            return arr;
          }.bind(this)
        });        
        this.setState({
          fields: fields,
          fieldsSync: true,
        })
      }
    }
  }

  convertArrForMultiselect(data) {
    const projectList = path(['projects', 'list'], this.props) || [];    
    const projectNameArr = map(item => item.id, projectList);

    if(data.length > 0) {
      for (let item in data) {
        const index = projectNameArr.indexOf(data[item]);
        index >= 0 ? projectList[index].value = true : 0;
      }
    }

    return projectList;
  }

  convertArrToSend(data) {
    const selectedArr = filter(item => item.checked, data.project_ids);
    if (selectedArr.length > 0) {
      data.project_ids = map(item => item.value, selectedArr).join(',');
    }

    return data;
  }

  fetchDataRouteById() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.getDataById(id);
  }

  cancel() {
    this.props.goToBoardEditor();
  }

  getShopList() {
    const shopSource = path(['shops', 'list'], this.props) || [];
    const shopList = [{
      value: 0,
      text: 'Select Shop'
    }];

    for (let i = 0; i < shopSource.length; i++) {
      shopList.push({
        value: shopSource[i].id,
        text: shopSource[i].name,
      })
    }
    return shopList;
  }

  getProjectList() {
    const projectSource = path(['projects', 'list'], this.props) || [];
    const projectList = [];

    for (let i = 0; i < projectSource.length; i++) {
      projectList.push({
        value: projectSource[i].id,
        checked: false,
        label: projectSource[i].name,
      })
    }
    return projectList;
  }

  submit(e) {
    e.preventDefault();
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      let data = processFields(this.state.fields);      
      data.board_id = 1;
      this.props.saveForm(
        path(['boardLane', 'lane', 'id'], this.props),
        this.convertArrToSend(data));
    }
    return false;
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  render() {
    const hasAccessForEdit = hasAccess({
      'permAreaKey': 'boardSettings',
      'permTypeKey': 'edit',
      'idForCheckingAuthor': path(['boardLane', 'lane', 'user_id'], this.props)
    });
    const disableFieldForEdit = !hasAccessForEdit;
    return (
      <div className="row">
        <div className="col">
          <Breadcrumbs list={[
             { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
             { url: '/pages/boardsettings', icon: 'settings', name: 'Board Settings' },
             { icon: 'edit', name: 'Edit Lane' },
           ]} />
          <div className="card rounded">
            <div className="card-header rounded-top">
              Edit Lane
            </div>
            <div className="card-block">
              <div className="col-12" style={{ paddingBottom: '40px' }}>
                <button
                  className={'btn btn-danger btn-outline float-right'}
                  style={{ marginLeft: '10px' }}
                  onClick={this.cancel}
                >
                  <i className="fa fa-remove"></i>
                  <span style={{ paddingLeft: '3px' }}>Cancel</span>
                </button>
                {hasAccessForEdit &&
                <button className={'btn btn-success btn-outline float-right'} onClick={this.submit}>
                  <i className="fa fa-check"></i>
                  <span style={{ paddingLeft: '3px' }}>Save & Continue</span>
                </button>
                }
              </div>
              <form onSubmit={this.submit}>
                <div className="col-12">
                  <Select
                    disabled={disableFieldForEdit}
                    options={this.getShopList()}
                    field={this.state.fields['shop_id']}
                    onChange={this.changeFormValue}
                  />
                  <Input
                    disabled={disableFieldForEdit}
                    field={this.state.fields['label']}
                    onChange={this.changeFormValue}
                  />
                  <TextArea
                    disabled={disableFieldForEdit}
                    field={this.state.fields['description']}
                    onChange={this.changeFormValue}
                  />
                  <MultiSelect
                    disabled={disableFieldForEdit}
                    options={this.state.fields.project_ids.value.length > 0 ? this.state.fields.project_ids.value : this.getProjectList()}                    
                    field={this.state.fields['project_ids']}
                    onChange={this.changeFormValue}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    goToBoardEditor: () => {
      dispatch(push('/pages/boardsettings'));
    },
    getDataById: (id) => {      
      fetchLaneById(id)(dispatch);
    },
    saveForm: (id, data) => {
      refreshLane(id, data)(dispatch);
    },
    shopList: () => {
      fetchShops()(dispatch);
    },
    projectList: () => {      
      getList()(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditLane);



// WEBPACK FOOTER //
// ./src/containers/EditLane/index.js